import React from 'react';
import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import * as Styled from './EmptyStateStyles';

function EmptyState() {
  return (
    <Styled.Content>
      <Styled.WrapperIcon>
        <FuelIcon size="large" name="map-pin" />
      </Styled.WrapperIcon>
      <Styled.WrapperText>
        <FuelTypography size="body-lg" weight="bold">
          No momento não encontramos motoristas com a localização ativa
        </FuelTypography>
        <FuelTypography size="body-sm" color="neutral-default" weight="medium">
          Para aparecer no mapa, o motorista deve compartilhar sua localização
          com a Fretebras
        </FuelTypography>
      </Styled.WrapperText>
    </Styled.Content>
  );
}

export default EmptyState;
